import _typeof from "/opt/render/project/src/node_modules/@babel/runtime/helpers/esm/typeof.js";
import "core-js/modules/es.function.name.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-c68eca22"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = /*#__PURE__*/_createTextVNode(" It seems like you didn't validate your email yet. Please ");

var _hoisted_2 = /*#__PURE__*/_createTextVNode("click here");

var _hoisted_3 = /*#__PURE__*/_createTextVNode(" if you have trouble doing so. ");

import { onMounted, onUnmounted, ref } from "vue";
import { useRoute } from "vue-router";
import { useUXStore } from "@/store/ux";
import { useUserStore } from "@/store/user";
import { usePermissionStore } from "@/store/permission";
import Navigation from "@/components/Navigation.vue";
import CookiesBanner from "@/components/CookiesBanner.vue";
import Link from "@/components/utils/Link.vue";
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var route = useRoute();
    var uxStore = useUXStore();
    var userStore = useUserStore();
    var permissionStore = usePermissionStore();
    var showCookiesBanner = process.env.VUE_APP_COOKIES_BANNER === "true";
    var content = ref(null);
    var scrollTo = window.scrollTo;
    onMounted(function () {
      window.scrollTo = function (arg1, arg2) {
        var _content$value;

        var x;
        var y = arg2;

        if (typeof arg1 === "number") {
          x = arg1;
        } else if (_typeof(arg1) === "object") {
          x = arg1.left;
          y = arg1.top;
        }

        (_content$value = content.value) === null || _content$value === void 0 ? void 0 : _content$value.scrollTo(x || 0, y || 0);
      };
    });
    onUnmounted(function () {
      window.scrollTo = scrollTo;
    });
    return function (_ctx, _cache) {
      var _component_n_layout_header = _resolveComponent("n-layout-header");

      var _component_n_el = _resolveComponent("n-el");

      var _component_n_alert = _resolveComponent("n-alert");

      var _component_router_view = _resolveComponent("router-view");

      var _component_Footer = _resolveComponent("Footer");

      var _component_n_layout_footer = _resolveComponent("n-layout-footer");

      var _component_n_layout_content = _resolveComponent("n-layout-content");

      var _component_n_layout = _resolveComponent("n-layout");

      return _openBlock(), _createBlock(_component_n_layout, {
        class: _normalizeClass("page h-100 theme-".concat(_unref(uxStore).theme))
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_n_el, null, {
            default: _withCtx(function () {
              return [_createVNode(_component_n_layout_header, null, {
                default: _withCtx(function () {
                  return [_createVNode(Navigation)];
                }),
                _: 1
              })];
            }),
            _: 1
          }), _createVNode(_component_n_layout_content, {
            ref_key: "content",
            ref: content,
            class: "page-content"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_Transition, {
                name: "fade",
                mode: "out-in"
              }, {
                default: _withCtx(function () {
                  return [_unref(route).name && _unref(userStore).user && !_unref(userStore).user.emailConfirmed && _unref(route).name !== 'Account' ? (_openBlock(), _createBlock(_component_n_alert, {
                    key: 0,
                    type: "warning",
                    "show-icon": false,
                    class: "spotlight text-center rounded-0 unbordered"
                  }, {
                    default: _withCtx(function () {
                      return [_hoisted_1, _createVNode(Link, {
                        to: {
                          name: 'Account'
                        }
                      }, {
                        default: _withCtx(function () {
                          return [_hoisted_2];
                        }),
                        _: 1
                      }), _hoisted_3];
                    }),
                    _: 1
                  })) : _createCommentVNode("", true)];
                }),
                _: 1
              }), _createVNode(_component_n_el, {
                class: "main flex-fill d-flex flex-column"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_router_view, null, {
                    default: _withCtx(function (_ref) {
                      var Component = _ref.Component;
                      return [_createVNode(_Transition, {
                        name: "fade",
                        mode: "out-in"
                      }, {
                        default: _withCtx(function () {
                          return [(_openBlock(), _createBlock(_resolveDynamicComponent(Component)))];
                        }),
                        _: 2
                      }, 1024)];
                    }),
                    _: 1
                  })];
                }),
                _: 1
              }), _createVNode(_component_n_layout_footer, null, {
                default: _withCtx(function () {
                  return [_createVNode(_component_Footer)];
                }),
                _: 1
              })];
            }),
            _: 1
          }, 512), _createVNode(_Transition, {
            name: "fade"
          }, {
            default: _withCtx(function () {
              return [showCookiesBanner && _unref(permissionStore).cookies === false ? (_openBlock(), _createBlock(_component_n_el, {
                key: 0,
                class: "position-fixed bottom-0 w-100 shadow-lg c-shape"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(CookiesBanner)];
                }),
                _: 1
              })) : _createCommentVNode("", true)];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["class"]);
    };
  }
});